import React from "react"
import PropTypes from "prop-types"
import { Link } from "gatsby"

import { colourScheme } from "../constants"

const Thumbnail = ({ to, src, alt }) => (
  <Link to={to} style={{}}>
    <img src={src} alt={alt} style={{ margin: 0 }} />
    {/* {alt} */}
  </Link>
)

Thumbnail.propTypes = {
  to: PropTypes.string.isRequired,
  src: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
}

Thumbnail.defaultProps = {}

export default Thumbnail
